// import React from 'react';
// import StatusBadge from './StatusBadge';

// const ProjectRow = ({ p, handleDelete }) => {
//   return (
//     <tr>
//       <td>#{p.id}</td>
//       <td>{p.name}</td>
//       <td>{p.description}</td>
//       <td><StatusBadge status={p.status} /></td>
//       <td>{p.startDate}</td>
//       <td>{p.endDate}</td>
//       <td>{new Date(p.createdAt).toLocaleString()}</td>
//       <td>
//         <button className="btn-danger" onClick={() => handleDelete(p.id)}>
//           Delete
//         </button>
//       </td>
//     </tr>
//   );
// };

// export default ProjectRow;
import React, { useState } from 'react';
import StatusBadge from './StatusBadge';

/* ─── Styles ─────────────────────────────────────────────── */
const S = {
  td: (alt) => ({
    padding: '13px 16px',
    borderBottom: '1px solid #f0f3fa',
    color: '#2d3748',
    background: alt ? '#fafbff' : '#fff',
    verticalAlign: 'middle',
  }),
  srBadge: {
    display: 'inline-block',
    background: '#eef0ff',
    color: '#4361ee',
    borderRadius: 5,
    padding: '2px 8px',
    fontWeight: 700,
    fontSize: 12,
  },
  actionCell: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
  },
  btnEdit: {
    padding: '6px 14px',
    background: 'transparent',
    color: '#4361ee',
    border: '1.5px solid #c7d2fe',
    borderRadius: 7,
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background .15s, border-color .15s',
    whiteSpace: 'nowrap',
  },
  btnDanger: (deleting) => ({
    padding: '6px 14px',
    background: 'transparent',
    color: '#e53e3e',
    border: '1.5px solid #fed7d7',
    borderRadius: 7,
    fontSize: 12,
    fontWeight: 600,
    cursor: deleting ? 'not-allowed' : 'pointer',
    opacity: deleting ? 0.6 : 1,
    transition: 'background .15s, border-color .15s',
    whiteSpace: 'nowrap',
  }),
  italic: {
    fontStyle: 'italic',
    color: '#c4cdd8',
  },
};

const formatDate = (date) =>
  date
    ? new Date(date).toLocaleDateString('en-IN', {
        day: '2-digit', month: 'short', year: 'numeric',
      })
    : null;

/* ─── ProjectRow ─────────────────────────────────────────── */
const ProjectRow = ({ p, index, handleDelete, handleEdit }) => {
  const [deleting, setDeleting] = useState(false);
  const alt = index % 2;

  const onDelete = async () => {
  const confirmDelete = window.confirm("Are you sure you want to delete this project?");

  if (!confirmDelete) return; // ❌ Cancel clicked

  setDeleting(true);
  await handleDelete(p.id);
  setDeleting(false);
};


  

  return (
    <tr>
      {/* Sr. No */}
      <td style={S.td(alt)}>
        <span style={S.srBadge}>{index + 1}</span>
      </td>

      {/* Name */}
      <td style={{ ...S.td(alt), fontWeight: 600, color: '#1a2340', whiteSpace: 'nowrap' }}>
        {p.name}
      </td>

      {/* Description */}
      <td style={{ ...S.td(alt), color: '#718096', maxWidth: 220 }}>
        {p.description || <span style={S.italic}>No description</span>}
      </td>

      {/* Status */}
      <td style={S.td(alt)}>
        <StatusBadge status={p.status} />
      </td>

      {/* Start Date */}
      <td style={{ ...S.td(alt), color: '#8892a4', fontSize: 12.5, whiteSpace: 'nowrap' }}>
        {formatDate(p.startDate) || <span style={S.italic}>—</span>}
      </td>

      {/* End Date */}
      <td style={{ ...S.td(alt), color: '#8892a4', fontSize: 12.5, whiteSpace: 'nowrap' }}>
        {formatDate(p.endDate) || <span style={S.italic}>—</span>}
      </td>

      {/* Created At */}
      <td style={{ ...S.td(alt), color: '#8892a4', fontSize: 12.5, whiteSpace: 'nowrap' }}>
        {new Date(p.createdAt).toLocaleString('en-IN', {
          day: '2-digit', month: 'short', year: 'numeric',
          hour: '2-digit', minute: '2-digit',
        })}
      </td>

      {/* Action */}
      <td style={S.td(alt)}>
        <div style={S.actionCell}>
          <button style={S.btnEdit} onClick={() => handleEdit(p)}>
            ✏️ Edit
          </button>
          <button
            style={S.btnDanger(deleting)}
            onClick={onDelete}
            disabled={deleting}
          >
            {deleting ? 'Deleting…' : '🗑 Delete'}
          </button>
        </div>
      </td>
    </tr>
  );
};

export default ProjectRow;